import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import styles from "./NavBar.module.scss";

const NavBar = ({ items, currentPage }) => {
  return (
    <div className={styles.navBar}>
      <div className={styles.container}>
        {items.map((item, index) => {
          const itemClassNames = classNames(styles.item, {
            [styles.teal]: item.color === "teal",
            [styles.active]: item.to.slice(0, 6) === currentPage.slice(0, 6),
          });

          return (
            <div className={styles.itemContainer} key={index}>
              <Link to={item.to} className={itemClassNames}>
                <div className={styles.iconContainer}>{item.icon}</div>
                <div className={styles.label}>{item.title}</div>
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NavBar;
